// D:\Event\frontend\src\components\Award.js
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./award.css";
import eventVideo from "../video/intro3.mp4";
import { backend_url } from "../constants/backend";

function Award() {
  const location = useLocation();
  const navigate = useNavigate();


  const [showQuestionAwards, setShowQuestionAwards] = useState(false);
  const [showAwardsList, setShowAwardsList] = useState(false);
 

  const [selectedAwards, setSelectedAwards] = useState(() => new Set());

  // which group user chose (award1 / award2)
  const [selectedAwardGroup, setSelectedAwardGroup] = useState(null);

  const [submittingAwards, setSubmittingAwards] = useState(false);

  // description popup
  const [popupText, setPopupText] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  // status popup (center)
  const [statusPopup, setStatusPopup] = useState({ message: "", type: "" });

  const [showPlayButton, setShowPlayButton] = useState(true);

  const emailFromState = location?.state?.email;
  const emailFromSession = sessionStorage.getItem("registeredEmail");
  const email = emailFromState || emailFromSession || "";

  // video ref
  const videoRef = useRef(null);

  useEffect(() => {
    console.log("Registered email:", email);
  }, [email]);

  // autoplay attempt (keep as you had)
  useEffect(() => {
    const tryPlay = () => {
      if (videoRef.current) {
        const playPromise = videoRef.current.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              setShowPlayButton(false);
            })
            .catch(() => {
              // Browser blocked autoplay with sound - wait for user click
              const resumePlay = () => {
                if (videoRef.current) {
                  videoRef.current.play();
                  setShowPlayButton(false);
                }
                window.removeEventListener("click", resumePlay);
              };
              window.addEventListener("click", resumePlay);
            });
        }
      }
    };

    // ONLY try autoplay on first landing (video screen)
    if (
      !showQuestionAwards &&
      !showAwardsList
    ) {
      tryPlay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showStatusPopup = (message, type = "success") => {
    setStatusPopup({ message, type });
    setTimeout(() => {
      setStatusPopup({ message: "", type: "" });
    }, 2000);
  };

  // description popup
  const DescriptionPopup = () => {
    if (!showPopup) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.3)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9998,
        }}
      >
        <div
          style={{
            width: "50%",
            background: "rgba(29, 35, 64, 0.9)",
            borderRadius: 12,
            padding: 20,
            textAlign: "center",
          }}
        >
          <h3 style={{ marginBottom: 10, fontWeight: 700, color: "white" }}>
            Award Description
          </h3>

          <p style={{ fontSize: 16, color: "white", lineHeight: "22px" }}>
            {popupText}
          </p>

          <button
            onClick={() => setShowPopup(false)}
            style={{
              marginTop: 20,
              width: "100px",
              padding: 12,
              borderRadius: 10,
              background: "#1f6feb",
              color: "white",
              fontWeight: 700,
              border: "none",
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  };

  // status popup (center)
  const StatusPopup = () => {
    if (!statusPopup.message) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: statusPopup.type === "success" ? "#16a34a" : "#dc2626",
          color: "white",
          padding: "14px 24px",
          borderRadius: 12,
          fontSize: 16,
          fontWeight: 700,
          boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
          zIndex: 9999,
          textAlign: "center",
          maxWidth: "80vw",
        }}
      >
        {statusPopup.message}
      </div>
    );
  };

  // Award descriptions
  const awardDescriptions = {
    "The PeoplePulse Vanguard Award":
      "Honors HR leaders who set the rhythm for people transformation.",
    "The TalentAlchemy Excellence Award":
      "For HR or L&D professionals who turn potential into high performance through innovative practices.",
    "The Stratovate Impact Award":
      "Recognizes startups or teams bringing breakthrough strategic innovations into the ecosystem.",

    "The NexSphere Rising Technovator Award":
      "For emerging startups or individuals revolutionizing HRTech, Al, or corporate workflows.",
    "The Luminary Trail Achiever Award":
      "For individuals whose work lights the path for organizational growth and excellence.",
    "The Quantum Leap Catalyst Award":
      "For a person or team that caused a transformative, high-velocity change within their company or industry.",
  };

  const toggleDescription = (name) => {
    setPopupText(awardDescriptions[name]);
    setShowPopup(true);
  };




  // Selection toggles
  const toggleAward = (name) => {
    setSelectedAwards((prev) => {
      const s = new Set(prev);
      s.has(name) ? s.delete(name) : s.add(name);
      return s;
    });
  };



  // 🔁 UPDATED: use backend_url instead of postSelectionApi, but keep same behavior
  async function postSelection(payload) {
    try {
      const resp = await fetch(`${backend_url}/award/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const text = await resp.text();
      let data = {};
      try {
        data = text ? JSON.parse(text) : {};
      } catch {
        data = {};
      }

      if (!resp.ok) {
        const status = resp.status;
        const message =
          data.detail || data.message || JSON.stringify(data) || "Server error";

        const error = new Error(`Server returned ${status} ${message}`);
        error.status = status;
        throw error;
      }

      return data;
    } catch (err) {
      if (!err.status) {
        err.status = 0;
      }
      throw err;
    }
  }

  const submitAwards = async () => {
    if (submittingAwards) return;
    setSubmittingAwards(true);
    const arr = Array.from(selectedAwards);

    try {
      await postSelection({ email, selected_list: arr });
      showStatusPopup("Awards submitted successfully!", "success");
      setTimeout(() => {
        navigate("/endpage", { state: { email } });
      }, 1300);
    } catch {
      showStatusPopup("Failed to submit awards", "error");
    }
    setSubmittingAwards(false);
  };

 

  const handleSkip = async () => {
    navigate("/endpage", { state: { email } });
  };

  // When video finishes, open the awards question
  const handleVideoEnd = () => {
    setShowQuestionAwards(true);
  };

  /* Reusable Button */
  const BlueButton = ({ label, checked, onClick, onShowDescription }) => {
    return (
      <button
        onClick={() => {
          if (onClick) onClick();
          if (onShowDescription) onShowDescription();
        }}
        className={`blue-btn ${checked ? "active" : ""}`}
      >
        {checked ? `${label} ✔` : label}
      </button>
    );
  };

  const SubmitButton = ({ label, onClick, loading }) => (
    <div style={{ marginTop: 12 }}>
      <button
        onClick={onClick}
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px",
          borderRadius: 20,
          border: "2px solid #1f6feb",
          background: "rgb(212 213 227)",
          color: "#0850bcff",
          fontSize: 16,
          fontWeight: 700,
        }}
      >
        {loading ? "Submitting..." : label}
      </button>
    </div>
  );

  // ✅ detect "video screen" to make card wider only there
  const isVideoScreen =
    !showQuestionAwards && !showAwardsList ;

  return (
    <div className="award-container react-background">
      {/* Center status popup */}
      <StatusPopup />
      {/* Existing description popup */}
      <DescriptionPopup />

      <div
        className={`award-card ${isVideoScreen ? "award-card-video" : ""}`}
        style={{ paddingBottom: 30 }}
      >
        {/* HEADER + VIDEO */}
        {isVideoScreen && (
          <>
            <div className="award-header main-title">
              <h2
                style={{
                  fontFamily: "'Orbitron', sans-serif",
                  textTransform: "uppercase",
                  fontSize: "18px",
                  backgroundColor: "#4a889d",
                  borderRadius: "11px",
                  padding: "8px 16px",
                  textAlign: "center",
                  color: "#fff",
                  fontWeight: "normal",
                }}
              >
                OUR EVENTS
              </h2>
            </div>

            {/* 🔥 New responsive video area */}
            <div className="award-video-wrapper">
              <div className="award-video-box">
                <video
                  ref={videoRef}
                  src={eventVideo}
                  className="award-video"
                  playsInline
                  controls={false}
                  onEnded={handleVideoEnd}
                  disablePictureInPicture
                  controlsList="nodownload noplaybackrate nofullscreen noremoteplayback"
                />

                {showPlayButton && (
                  <button
                    type="button"
                    className="award-video-play"
                    onClick={() => {
                      if (videoRef.current) {
                        videoRef.current
                          .play()
                          .then(() => {
                            setShowPlayButton(false);
                          })
                          .catch((err) =>
                            console.error("Error playing video:", err)
                          );
                      }
                    }}
                  >
                    ▶
                  </button>
                )}
              </div>
            </div>
          </>
        )}

        {/* QUESTION: Awards */}
        {showQuestionAwards && (
          <div style={{ marginTop: 240 }}>
            <BlueButton label="ENTER NEXUS AWARDS" />

            {/* Award1 & Award2 buttons in one row */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: 55,
                marginTop: 16,
              }}
            >
              <div style={{ width: "40%" }}>
                <BlueButton
                  label="NEX SPARK"
                  onClick={() => {
                    setSelectedAwardGroup("group1");
                    setShowAwardsList(true);
                    setShowQuestionAwards(false);
                  }}
                />
              </div>

              <div style={{ width: "40%" }}>
                <BlueButton
                  label="NEX HR"
                  onClick={() => {
                    setSelectedAwardGroup("group2");
                    setShowAwardsList(true);
                    setShowQuestionAwards(false);
                  }}
                />
              </div>
            </div>

            <div
              style={{
                marginTop: 10,
                display: "flex",
                justifyContent: "flex-end",
                width: "80px",
                marginLeft: "auto",
              }}
            >
              <button className="skip-clean-btn" onClick={handleSkip}>
                Skip →
              </button>
            </div>
          </div>
        )}

        {/* AWARDS LIST – GROUP 1 (Award1) */}
        {showAwardsList && selectedAwardGroup === "group1" && (
          <div style={{ marginTop: 190 }}>
            <h3
              style={{
                fontFamily: "'Orbitron', sans-serif",
                textTransform: "uppercase",
                fontSize: "18px",
                background: "rgb(212 213 227)",
                borderRadius: "11px",
                padding: "8px 16px",
                textAlign: "center",
                color: "#4136a0ff",
                fontWeight: 700,
              }}
            >
              Select your interested awards 👇
            </h3>

            {/* Vanguard Award */}
            <div className="award-block">
              <BlueButton
                label="The PeoplePulse Vanguard Award"
                checked={selectedAwards.has("The PeoplePulse Vanguard Award")}
                onClick={() => toggleAward("The PeoplePulse Vanguard Award")}
                onShowDescription={() =>
                  toggleDescription("The PeoplePulse Vanguard Award")
                }
              />
            </div>

            {/* Quantum Leap Catalyst Award */}
            <div className="award-block">
              <BlueButton
                label="The Quantum Leap Catalyst Award"
                checked={selectedAwards.has("The Quantum Leap Catalyst Award")}
                onClick={() => toggleAward("The Quantum Leap Catalyst Award")}
                onShowDescription={() =>
                  toggleDescription("The Quantum Leap Catalyst Award")
                }
              />
            </div>

            {/* Stratovate Impact Award */}
            <div className="award-block">
              <BlueButton
                label="The Stratovate Impact Award"
                checked={selectedAwards.has("The Stratovate Impact Award")}
                onClick={() => toggleAward("The Stratovate Impact Award")}
                onShowDescription={() =>
                  toggleDescription("The Stratovate Impact Award")
                }
              />
            </div>

            {/* Submit awards */}
            <SubmitButton
              label="Submit Awards"
              onClick={submitAwards}
              loading={submittingAwards}
            />

            {/* MOBILE BACK + SKIP */}
            <div className="mobile-award-actions">
              <button
                className="action-btn back-btn"
                onClick={() => {
                  setShowAwardsList(false);
                  setShowQuestionAwards(true);
                }}
              >
                ← Back
              </button>

              <button className="action-btn skip-btn" onClick={handleSkip}>
                Skip →
              </button>
            </div>
          </div>
        )}

        {/* AWARDS LIST – GROUP 2 (Award2) */}
        {showAwardsList && selectedAwardGroup === "group2" && (
          <div style={{ marginTop: 190 }}>
            <h3
              style={{
                fontFamily: "'Orbitron', sans-serif",
                textTransform: "uppercase",
                fontSize: "18px",
                background: "rgb(212 213 227)",
                borderRadius: "11px",
                padding: "8px 16px",
                textAlign: "center",
                color: "#4136a0ff",
                fontWeight: 700,
              }}
            >
              Select your interested awards 👇
            </h3>

            {/* NexSphere Rising Technovator Award */}
            <div className="award-block">
              <BlueButton
                label="The NexSphere Rising Technovator Award"
                checked={selectedAwards.has(
                  "The NexSphere Rising Technovator Award"
                )}
                onClick={() =>
                  toggleAward("The NexSphere Rising Technovator Award")
                }
                onShowDescription={() =>
                  toggleDescription("The NexSphere Rising Technovator Award")
                }
              />
            </div>

            {/* TalentAlchemy Excellence Award */}
            <div className="award-block">
              <BlueButton
                label="The TalentAlchemy Excellence Award"
                checked={selectedAwards.has(
                  "The TalentAlchemy Excellence Award"
                )}
                onClick={() =>
                  toggleAward("The TalentAlchemy Excellence Award")
                }
                onShowDescription={() =>
                  toggleDescription("The TalentAlchemy Excellence Award")
                }
              />
            </div>

            {/* Luminary Trail Achiever Award */}
            <div className="award-block">
              <BlueButton
                label="The Luminary Trail Achiever Award"
                checked={selectedAwards.has(
                  "The Luminary Trail Achiever Award"
                )}
                onClick={() =>
                  toggleAward("The Luminary Trail Achiever Award")
                }
                onShowDescription={() =>
                  toggleDescription("The Luminary Trail Achiever Award")
                }
              />
            </div>

            {/* Submit awards */}
            <SubmitButton
              label="Submit Awards"
              onClick={submitAwards}
              loading={submittingAwards}
            />

            {/* MOBILE BACK + SKIP */}
            <div className="mobile-award-actions">
              <button
                className="action-btn back-btn"
                onClick={() => {
                  setShowAwardsList(false);
                  setShowQuestionAwards(true);
                }}
              >
                ← Back
              </button>

              <button className="action-btn skip-btn" onClick={handleSkip}>
                Skip →
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Award;
